//@ts-nocheck
import { useContext } from 'react';
import RootNavigatorContext from './RootNavigatorContext';

export default function useRootNavigatorContext() : IRootNavigatorContext {

    const context : IRootNavigatorContext = useContext(RootNavigatorContext);
    return context;
}